import React, { useState } from 'react';
import { Card, Form, Input, Button, message, Alert } from 'antd';
import axios from 'axios';
import NavbarPicking from '../../components/navbarPicking/navbarPicking';
import './registroBodega.css';

const RegistroBodega = () => {
    const [form] = Form.useForm();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (values) => {
        setIsSubmitting(true);
        const id_user = localStorage.getItem('usuario_id');
        
        try {
            const response = await axios.post(
                `https://99envios.app/api/picking/bodega/asignar-bodega-propia/${id_user}`,
                {
                    correo: values.correo,
                    contrasena: values.contrasena
                }
            );

            if (response.data.exito) {
                message.success('Bodega asignada exitosamente');
                form.resetFields();
            } else {
                message.error('Error al asignar bodega');
            }
        } catch (error) {
            message.error('Error al conectar con el servidor');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <NavbarPicking title="Registro de Bodega" />
            <div className="registro-bodega-container">
                <Card title="Registro de Bodega Propia" className="registro-form-card">
                    <Alert
                        message="Nota Importante"
                        description="Este formulario se utilizará para crear y asignar una bodega propia. Por favor ingrese las credenciales solicitadas."
                        type="info"
                        showIcon
                        style={{ marginBottom: 24 }}
                    />
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={handleSubmit}
                    >
                        <Form.Item
                            label="Correo Electrónico"
                            name="correo"
                            rules={[
                                { required: true, message: 'Por favor ingrese el correo' },
                                { type: 'email', message: 'Ingrese un correo válido' }
                            ]}
                        >
                            <Input placeholder="Ingrese el correo" />
                        </Form.Item>

                        <Form.Item
                            label="Contraseña"
                            name="contrasena"
                            rules={[
                                { required: true, message: 'Por favor ingrese la contraseña' },
                                { min: 6, message: 'La contraseña debe tener al menos 6 caracteres' }
                            ]}
                        >
                            <Input.Password placeholder="Ingrese la contraseña" />
                        </Form.Item>

                        <Form.Item>
                            <Button 
                                type="primary" 
                                htmlType="submit" 
                                loading={isSubmitting}
                                block
                            >
                                Registrar Bodega
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
            </div>
        </>
    );
};

export default RegistroBodega;
